import {getPortfolioLogos} from '../sanity/sanity';

async function GetLogo(){

  const userData = await getPortfolioLogos();
 
  return userData

}

export default GetLogo;